// components/industry-templates/ConstructionEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { HardHat, Building2, Hammer, TrendingUp } from 'lucide-react';

export const ConstructionEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Construction Tech */}
      {industryData?.construction_tech && (
        <Card className="border-0 bg-gradient-to-br from-orange-500/20 to-amber-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <HardHat className="w-8 h-8" style={{ color: theme.primary }} />
              Construction Technologies
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {industryData.construction_tech.map((tech: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                  <div className="flex items-start gap-4">
                    <div className="text-3xl">🏗️</div>
                    <div>
                      <h3 className="text-xl font-bold text-white mb-2">{tech.name}</h3>
                      <p className="text-slate-300 text-sm mb-3">{tech.description}</p>
                      <Badge style={{ backgroundColor: theme.primary }}>{tech.category}</Badge>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Project Showcase */}
      {industryData?.project_showcase && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Building2 className="w-6 h-6" style={{ color: theme.primary }} />
              Mega Projects Showcase
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.project_showcase.map((project: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white mb-1">{project.name}</h4>
                  <p className="text-sm text-slate-400 mb-2">{project.location}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{project.value}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
